<template>
    <Page type="white" :header="(!isPWA && !isTgApp) ? header[lang].title : ''">
        <template v-slot:body>
            <div v-if="status" class="flex flex-column gap-3">
                <span v-if="status.status" class="flex">
                    Status: {{ status.status }}
                </span>
                <span v-if="status.ip" class="flex">
                    IP: {{ status.ip }}
                </span>
                <span v-if="status.timestamp" class="flex">
                    Timestamp: {{ status.timestamp }}
                </span>
                <span v-if="status.userAgent" class="flex">
                    UserAgent: {{ status.userAgent }}
                </span>
                <span v-if="status.environment" class="flex">
                    Environment: {{ status.environment }}
                </span>
                <span class="flex">
                    YM: {{ymClientId }}
                </span>
            </div>
            <div v-else class="text-center text-lg">
                <span class="text-center text-lg">Loading...</span>
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import Page     from '@/components/sides/Page.vue' 
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            header: {
                en:{
                    title: "Status Page",
                },
                ru:{
                    title: "Страница статуса",
                }
            },
            status: null,
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        ymClientId() {
            try { return this.$store.getters.StateYandexClientId
            } catch { return null } 
        }
    },
    components: {
        Page
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        async getStatus(){
            const status = await this.connect.GetStatus().then(res => res).catch(error => {})
            if (status) this.status = status
            else this.status = 'unknown'
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.getStatus()
        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>